<template>
  <div class="menu">
    <v-menu
      bottom
      left
      min-width="250"
    >
      <v-btn
        slot="activator"
        icon
      >
        <v-icon>more_vert</v-icon>
      </v-btn>

      <v-list>

        <v-list-tile
          v-if="isFile && hasPreview"
          @click="showPreviewDialog">
          <v-list-tile-action>
            <v-icon>visibility</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Podgląd</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="isDirPage && isAdmin"
          @click="showRenameDialog">
          <v-list-tile-action>
            <v-icon>edit</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Zmień nazwę</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          @click="showTagsDialog"
          v-if="isFile && isAdmin">
          <v-list-tile-action>
            <v-icon>label</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Zarządzaj tagami</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="isDirPage && isAdmin"
          @click="showMoveDialog">
          <v-list-tile-action>
            <v-icon>folder_open</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Przenieś do...</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="showDetailsDialog">
          <v-list-tile-action>
            <v-icon>info</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Pokaż szczegóły</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="isFile && isAdmin && hasOcr"
          @click="downloadOcrFile"
        >
          <v-list-tile-action >
            <v-icon>subject</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Stwórz OCR</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="idDir && isAdmin"
          @click="showPermissionsDialog">
          <v-list-tile-action>
            <v-icon>person_add</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Zarządzaj dostępem</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="gdAccess && isFile"
          @click="showShareDialog">
          <v-list-tile-action>
            <v-icon>share</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Udostępnij na Google Drive</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>


        <v-list-tile
          v-if="isFile"
          @click="downloadFile">
          <v-list-tile-action>
            <v-icon>get_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Pobierz</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="isDirPage && isAdmin"
          @click="showDeleteDialog">
          <v-list-tile-action>
            <v-icon>delete</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Usuń</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { downloadInit, decodeUri } from '../../../helpers/helpers';
import { authorizeDownload, authorizeOcrDownload } from '../../../repository/files';

export default {
  name: 'file-menu',
  props: ['file'],
  computed: {
    ...mapGetters('user', [
      'details',
      'gdAccess',
      'role',
    ]),
    clientId() {
      return this.$route.params.clientId;
    },
    parentId() {
      return this.$route.params.id;
    },
    isAdmin() {
      return this.role === 'admin' || this.role === 'super-admin';
    },
    isDirPage() {
      return this.clientId && (this.parentId || this.$route.name === 'searchFiles');
    },
    idDir() {
      return this.file.type === 1;
    },
    hasPreview() {
      return this.file.preview_available;
    },
    hasOcr() {
      return this.file.has_ocr;
    },
    isFile() {
      return this.isDirPage && this.file.type !== 1;
    },
    viewParams() {
      return {
        client_id: this.clientId,
        parent_item_id: this.parentId,
      };
    },
  },
  methods: {
    ...mapActions('files', [
      'setDialogVisbility',
    ]),
    showDialog(dialogData) {
      const data = {
        ...dialogData,
        view: this.$route.name,
      };
      this.setDialogVisbility(data);
    },
    showRenameDialog() {
      const dialogData = {
        type: 'rename',
        id: this.file.id,
        fileType: this.file.type,
        name: this.file.name,
        viewParams: this.viewParams,
      };
      this.showDialog(dialogData);
    },
    showPreviewDialog() {
      const dialogData = {
        type: 'preview',
        id: this.file.id,
        name: this.file.name,
        mime: this.file.extension,
      };
      this.showDialog(dialogData);
    },
    showPermissionsDialog() {
      const dialogData = {
        type: 'permissions',
        data: {
          client_id: this.file.client_id,
          items_id: [this.file.id],
        },
        viewParams: this.viewParams,
      };
      this.showDialog(dialogData);
    },
    showDetailsDialog() {
      const dialogData = {
        type: 'details',
        name: this.file.name,
        id: this.file.id,
        fileType: this.file.type,
        extension: this.file.extension,
      };
      this.showDialog(dialogData);
    },
    showMoveDialog() {
      const dialogData = {
        type: 'move',
        items_id: [this.file.id],
        ...this.viewParams,
      };
      this.showDialog(dialogData);
    },
    showTagsDialog() {
      const dialogData = {
        type: 'tag',
        fileId: this.file.id,
        tags: this.file.tags,
        viewParams: this.viewParams,
      };
      this.showDialog(dialogData);
    },
    showDeleteDialog() {
      const dialogData = {
        type: 'delete',
        items_id: [this.file.id],
        viewParams: this.viewParams,
      };
      this.showDialog(dialogData);
    },
    showShareDialog() {
      const dialogData = {
        type: 'share',
        item_id: this.file.id,
      };
      this.showDialog(dialogData);
    },
    async downloadFile() {
      let file = await authorizeDownload(this.file.id);
      file = decodeUri(file.data.data.url);
      if (file) {
        downloadInit(file);
      }
    },
    async downloadOcrFile() {
      let file = await authorizeOcrDownload(this.file.id);
      file = decodeUri(file.data.data.url);
      if (file) {
        downloadInit(file);
      }
    },
  },
};
</script>

<style scoped>
  .menu {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 100;
  }
</style>
